import { projectContext } from "@/layouts/MainLayout"
import { useRequest } from "ahooks"
import { Card, Button, Table, Space } from "antd"
import Column from "antd/es/table/Column"
import { useContext } from "react"
import { IconFont } from '@/components/IconFont'
import { CaseModal, deleteProjectCase, getProjectCases } from "@/services/project/cases.service"
import AddEditCaseModal from "./AddEditCaseModal"

export const ProjectCases = () => {
  const { projectId } = useContext(projectContext)
  const { data: cases = [], loading, refresh } = useRequest(() => getProjectCases({pId: projectId}))

  return (
    <Card
      title='Cases'
      extra={
        <Button
          type="primary"
          size="small"
          icon={<IconFont type='icon-add' />}
          onClick={() => {
            AddEditCaseModal.show({
              projectId,
              onSuccess: () => {
                refresh()
              }
            })
          }}
        >Create</Button>
        
      }
    >
      <Table
        pagination={{ pageSize: 30 }}
        size='small'
        loading={false}
        dataSource={cases}
        rowKey={(record) => record.id}
      >
        <Column title='Number' align={'center'} dataIndex='number' />

        <Column title='Name' dataIndex='name' align={'center'} />


        <Column
          title='Actions'
          align={'center'}
          render={(_, record: CaseModal) => (
            <Space>
              <Button size="small" onClick={() => {
                AddEditCaseModal.show({
                  projectId,
                  projectCase: record,
                  onSuccess: () => {
                    refresh()
                  }
                })
              }}>Edit</Button>
              <Button size="small" danger onClick={async () => {
                await deleteProjectCase({id: record.id, pId: projectId})
                refresh()
              }}>Delete</Button>
            </Space>
          )}
        />
      </Table>
    </Card>
  )
}